import React from 'react';
import { ThemeProvider } from 'styled-components';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const setTheme = (modeOption) => (theme) => {
  if (!theme || theme && !theme.mode) {
    throw new Error("The `ColorMode` component expected a theme with a mode property but none was provided.");
  }
  let { mode } = theme;
  switch (modeOption) {
    case "light":
      mode = "light";
      break;
    case "dark":
      mode = "dark";
      break;
    case "invert":
      if (mode === "dark") {
        mode = "light";
      } else {
        mode = "dark";
      }
      break;
  }
  return __spreadProps(__spreadValues({}, theme), { mode });
};
const ColorMode = ({ mode, children }) => {
  return /* @__PURE__ */ React.createElement(ThemeProvider, {
    theme: setTheme(mode)
  }, children);
};

export { ColorMode, setTheme };
//# sourceMappingURL=ColorMode.es.js.map
